// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  UploadStatus,
} from "./types";


export default __t.row({
  progressId: __t.u64().primaryKey().name("progress_id"),
  userIdentity: __t.identity().name("user_identity"),
  assetId: __t.u64().name("asset_id"),
  versionId: __t.u64().name("version_id"),
  get status() {
    return UploadStatus;
  },
  totalFiles: __t.u32().name("total_files"),
  filesUploaded: __t.u32().name("files_uploaded"),
  totalBytes: __t.u64().name("total_bytes"),
  bytesUploaded: __t.u64().name("bytes_uploaded"),
  currentFile: __t.option(__t.string()).name("current_file"),
});
